export const radii = ['none', 'xs', 'sm', 'md', 'lg', 'base', 'xl', '2xl'];
export const isRadii = (x) => radii.includes(x);
